import { ITripLeg } from '../../../../../../../../models/trip-leg.model';
import { TranslationService } from '../../../../../../../../services/translation.service';
import { StopAreaHelper } from '../../../../../../../../helpers/stop-area.helper';
import { IAccessLink } from '../../../../../../../../models/access-link.model';
import { ILinkEndpoint } from '../../../../../../../../models/link-endpoint.model';
import { ICall } from '../../../../../../../../models/call.model';
import './style.scss';
import { LocationType } from '../../../../../../../../models/location-type.enum';
import { IConnectionLink } from '../../../../../../../../models/connection-link.model';
import { DistanceHelper } from '../../../../../../../../helpers/distance.helper';
import { DateHelper } from '../../../../../../../../helpers/date.helper';
import { Icon } from '../../../../../../../Shared/Icon';
import { IconMotif } from '../../../../../../../Shared/Icon/icon-motif.enum';
import { StopPointType } from '../../../../../../../../models/stop-point-type.enum';
import { t } from '../../../../../../../../services/texts.service';

function getName(call?: ICall, linkEndpoint?: ILinkEndpoint): string {
  if (linkEndpoint) {
    return `${StopAreaHelper.getNameWithoutMunicipality(linkEndpoint.name)}${linkEndpoint.platform ? ' ' + (linkEndpoint.stopPointType === StopPointType.trainStop ? t.track : t.platform) + ' ' + linkEndpoint.platform : ''}`;
  }
  return `${StopAreaHelper.getNameWithoutMunicipality(call?.stopPoint.name)}${call?.stopPoint.platform ? ' ' + (call?.stopPoint.stopPointType === StopPointType.trainStop ? t.track : t.platform) + ' ' + call?.stopPoint.platform : ''}`;
}

function getDistance(connectionLink?: IConnectionLink, accessLink?: IAccessLink): string {
  if (accessLink) {
    return DistanceHelper.format(accessLink.distanceInMeters);
  }
  return DistanceHelper.format(connectionLink?.distanceInMeters);
}

function getDuration(connectionLink?: IConnectionLink, accessLink?: IAccessLink): string {
  if (accessLink) {
    return DateHelper.formatAsHoursAndMinutes(accessLink.estimatedDurationInMinutes ?? accessLink.plannedDurationInMinutes);
  }
  return DateHelper.formatAsHoursAndMinutes(connectionLink?.estimatedDurationInMinutes ?? connectionLink?.plannedDurationInMinutes);
}

function getLocationTypeText(accessLink?: IAccessLink): string {
  if (accessLink) {
    if (accessLink.destination.locationType === LocationType.address) return TranslationService.get('common.address');
    if (accessLink.destination.locationType === LocationType.pointOfInterest) return TranslationService.get('common.poi');
  }
  return TranslationService.get('common.stop');
}

function AcccessLinkConnectionLinkDetails({
  connectionLink,
  accessLink,
  nextTripLeg,
  journeyId,
  onClose,
}: {
  connectionLink: IConnectionLink | undefined;
  accessLink: IAccessLink | undefined;
  nextTripLeg: ITripLeg | undefined;
  journeyId: number;
  onClose: () => void;
}) {
  const duration = getDuration(connectionLink, accessLink);
  return (
    <div className="acccess-link-connection-link-details">
      <div className="d-flex justify-content-between border-bottom mb-2 pb-1">
        <div className="d-flex align-items-center">
          <div className="flex-shrink-0">
            <Icon motif={IconMotif.Walk} altText="" className="me-1" />
          </div>
          <div className="d-flex flex-column flex-grow-1 text-color-gray-900">
            <span className="fw-bold">
              {TranslationService.get('travelplanner.goto')} {getName(connectionLink?.destination, accessLink?.destination)}
            </span>
            <span>{getLocationTypeText(accessLink)}</span>
          </div>
        </div>
        <button type="button" className="d-none d-md-block btn-close trip-leg-calls__btn-close d-print-none" aria-label={TranslationService.get('common.close')} onClick={onClose}></button>
        <button
          type="button"
          className="d-md-none btn-close trip-leg-calls__btn-close d-print-none"
          aria-label={TranslationService.get('common.close')}
          onClick={onClose}
          aria-controls={`journey-details-map-${journeyId}`}
          aria-expanded="true"
        ></button>
      </div>
      <div className="mb-2">
        {TranslationService.get('common.from')} {getName(connectionLink?.origin, accessLink?.origin)} {TranslationService.get('travelplanner.to').toLocaleLowerCase()}{' '}
        {getName(connectionLink?.destination, accessLink?.destination)}
      </div>
      <dl>
        {nextTripLeg && (
          <div className="acccess-link-connection-link-details__list-item acccess-link-connection-link-details__list-item--connecting-time">
            <dt>{TranslationService.get('common.interchange.time')}</dt>
            <dd>
              {nextTripLeg?.estimatedConnectingTimeInMinutes || nextTripLeg?.plannedConnectingTimeInMinutes} min ({TranslationService.get('travelplanner.includingwalkingtime')})
            </dd>
          </div>
        )}
        <div className="acccess-link-connection-link-details__list-item acccess-link-connection-link-details__list-item--distance">
          <dt>{TranslationService.get('travelplanner.distance')}</dt>
          <dd>{getDistance(connectionLink, accessLink)}</dd>
        </div>
        {duration !== '' && (
          <div className="acccess-link-connection-link-details__list-item acccess-link-connection-link-details__list-item--walking-time">
            <dt>{TranslationService.get('travelplanner.walkingtime')}</dt>
            <dd>{duration}</dd>
          </div>
        )}
      </dl>
    </div>
  );
}

export default AcccessLinkConnectionLinkDetails;
